export default function HappyOutline() {
  return (
    <div
      className="ion-icon-happy-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M387.469,289.593c-2.248-1.175-4.775-1.796-7.308-1.796c-5.956,0-11.358,3.287-14.104,8.588
		C347.804,331.731,304.605,352,256.004,352c-49.734,0-93.84-20.562-109.757-54.997c-2.589-5.589-8.244-9.199-14.407-9.199
		c-2.294,0-4.521,0.485-6.658,1.463c-7.926,3.674-11.397,13.117-7.734,21.057C138.454,355.765,194.135,384,256.004,384
		c60.34,0,114.604-27.281,138.241-73.055C398.254,303.184,395.201,293.598,387.469,289.593z"/>
	<path d="M412.793,231.174C402.312,217.593,389.024,208,368.137,208c-20.887,0-34.062,9.573-44.611,23.117
		c-5.502,7.062-4.525,16.633,3.746,22.207c2.914,1.963,6.347,2.676,9.928,2.676c5.395-0.001,10.507-2.109,13.67-6.179
		c3.45-4.435,7.707-9.821,17.268-9.821c9.61,0,13.832,5.361,17.23,9.777c3.178,4.104,8.305,6.223,13.717,6.223
		c3.581,0,7.007-0.708,9.922-2.683C416.558,248.185,418.257,238.25,412.793,231.174z"/>
	<path d="M188.792,231.174C178.312,217.593,165.024,208,144.137,208s-34.063,9.573-44.612,23.117
		c-5.501,7.062-4.525,16.633,3.747,22.207c2.914,1.963,6.346,2.676,9.927,2.676c5.395-0.001,10.507-2.109,13.669-6.179
		c3.451-4.435,7.708-9.821,17.269-9.821c9.61,0,13.832,5.361,17.23,9.777c3.177,4.104,8.304,6.223,13.716,6.223
		c3.582,0,7.007-0.708,9.922-2.683C192.558,248.185,194.257,238.25,188.792,231.174z"/>
	<path d="M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M391.765,391.765
		C355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765
		C156.5,83.972,204.715,64,256,64s99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256S428.028,355.5,391.765,391.765z"/>
</g>
</svg>
`,
      }}
    />
  )
}
